import { Box, Container, Group } from '@mantine/core';

import { HeaderLogo } from '@/components/atoms';
import { HeaderLinks } from '@/components/molecules';

export function MarketingHeader() {
  return (
    <Box component="header" style={{ borderBottom: `1px solid var(--mantine-color-ore-8)` }}>
      <Container size="lg">
        <Group align="center" p="sm" justify="space-between">
          <HeaderLogo />
          <HeaderLinks />
        </Group>
      </Container>
    </Box>
  );
}
